import { Theme } from '@eversports/react-components/design-tokens/theme'
import Card from '@eversports/react-components/primitives/Card'
import Flex from '@eversports/react-components/primitives/Flex'
import { makeStyles } from '@mui/styles'

import { EventBookableItem } from '../../../typings/BookableItem'
import Trainer from '../../../typings/Trainer'
import { SettleWith } from '../../../typings/Product'
import BookingDetailsImage from '../common/BookingDetailsImage'
import { BookingRequestDetailsContent } from '../common/BookingRequestDetailsContent'

interface Props {
  bookableItem: EventBookableItem
  trainer: Trainer | null
  start: string | null
  end: string | null
  settleWith?: SettleWith | null
}

const useStyles = makeStyles((theme: Theme) => ({
  activityInformation: {
    flex: '60%',
    padding: theme.layoutSpacing.wide,
  },
}))

export function DesktopBookingRequestDetails({ bookableItem, trainer, start, end, settleWith }: Props) {
  const classes = useStyles()

  return (
    <Card raised>
      <Flex justifyContent="space-between">
        <div className={classes.activityInformation}>
          <BookingRequestDetailsContent
            bookableItem={bookableItem}
            trainer={trainer}
            start={start}
            end={end}
            settleWith={settleWith}
          />
        </div>
        {bookableItem.activityImage && <BookingDetailsImage src={bookableItem.activityImage.large} />}
      </Flex>
    </Card>
  )
}
